import { render, staticRenderFns } from "./ProtocolsIcon.vue?vue&type=template&id=64557755&"
import script from "./ProtocolsIcon.vue?vue&type=script&lang=js&"
export * from "./ProtocolsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports